
const digest = '7070fdee6dd08d6db0e1df95eeb589b2e6259dd273878b2ff5fcbf8d2ff80e14';
const classes = {"wrapper":"_wrapper_1wj0i_1","title":"_title_1wj0i_8"};
const css = `._wrapper_1wj0i_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
}
._wrapper_1wj0i_1 ._title_1wj0i_8 {
  font-size: 14px;
  color: #9ea0a5;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  